import { Position } from './Position';

export class LabelLine {
    constructor(
        private ctx: CanvasRenderingContext2D,
        private point: Position,
        private labelX: number,
        private labelY: number
    ) {}

    draw(): void {
        this.ctx.setLineDash([]);
        this.ctx.strokeStyle = '#FFF';
        this.ctx.lineWidth = 1.5;
        this.ctx.beginPath();
        this.ctx.moveTo(this.point.x, this.point.y);
        this.ctx.lineTo(this.labelX, this.labelY);
        this.ctx.stroke();
        this.ctx.save();
    }
} 